/**
 * Bundled stake SFX (`assets/Sounds/ui-tap-stake.mp3`). Metro exposes different shapes per platform
 * (number module id on native, string URL or `{ default }` on web) — normalize here.
 */

import {
  resolveBundledMp3NativeSource,
  resolveBundledMp3UriForWeb,
} from './bundledMp3Module.helper';

// eslint-disable-next-line @typescript-eslint/no-require-imports
const STAKE_MP3_MODULE = require('../../../assets/Sounds/ui-tap-stake.mp3') as unknown;

export function isStakeSoundCdnOnly(): boolean {
  return process.env.EXPO_PUBLIC_SOUND_STAKE_FROM_CDN === 'true';
}

/** Native `expo-audio` source: asset module id, `{ uri }` from Metro, or null → caller uses CDN URI. */
export function getNativeStakeSoundSource(): number | { uri: string } | null {
  if (isStakeSoundCdnOnly()) return null;
  return resolveBundledMp3NativeSource(STAKE_MP3_MODULE);
}

/** Web: absolute URL to bundled MP3 (for fetch / HTMLAudio). */
export function getStakeBundledUriForWeb(): string | null {
  if (isStakeSoundCdnOnly()) return null;
  return resolveBundledMp3UriForWeb(STAKE_MP3_MODULE);
}
